import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const GameContext = createContext(null);

const EMOJI_CATEGORIES = {
  animals: ["🐕", "🐈", "🐁", "🐘", "🦁", "🐻", "🐼", "🦊", "🐰", "🐨", "🦄", "🐴", "🐮", "🐷", "🐸", "🐵", "🦋", "🐝", "🐞", "🐢", "🐍", "🦎", "🐠", "🐬", "🦈", "🐙", "🦀", "🐧", "🦅", "🦆", "🦉", "🐺", "🦝", "🦔", "🦩", "🦚", "🦜", "🐿️", "🦫", "🦦", "🦥", "🦨"],
  fruits: ["🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🥑", "🍈", "🍏", "🫒", "🫑"],
  food: ["🍕", "🍔", "🍟", "🌭", "🥪", "🌮", "🌯", "🥗", "🍝", "🍜", "🍣", "🍱", "🍛", "🍚", "🥟", "🍤", "🍩", "🍪", "🎂", "🍰", "🧁", "🍫", "🍬", "🍭", "🥐", "🥨", "🥯", "🧇", "🥞", "🧈", "🥓", "🥩", "🍗", "🍖"],
  vehicles: ["🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑", "🚒", "🚐", "🛻", "🚚", "🚜", "🏍️", "🛵", "🚲", "🚂", "🚁", "✈️", "🚀", "🛸", "🚢", "⛵", "🚤", "🛶", "🚇", "🚊", "🚉", "🛺", "🚠", "🚡"],
  sports: ["⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱", "🏓", "🏸", "🥊", "🥋", "⛳", "🎿", "🏂", "🛷", "🥌", "🎯", "🪀", "🏹", "🥅", "⛸️", "🤿", "🎣", "🪃"],
  nature: ["🌸", "🌺", "🌻", "🌹", "🌷", "🌱", "🌲", "🌳", "🌴", "🌵", "🍀", "🍁", "🍂", "🍃", "🌿", "☀️", "🌙", "⭐", "🌈", "☁️", "❄️", "🌊", "🔥", "💧", "🌍", "🪨", "🪵", "🍄", "🐚", "🪸", "🪷"],
  music: ["🎵", "🎶", "🎸", "🎹", "🎺", "🎷", "🥁", "🎻", "🪕", "🎤", "🎧", "📻", "🪗", "🪘", "📯", "🪈"],
  faces: ["😀", "😃", "😄", "😁", "😆", "🤣", "😂", "🙂", "😊", "😇", "🥰", "😍", "🤩", "😎", "🤓", "😤", "😠", "😱", "🥳", "😴", "🤔", "🤫", "🤥", "😬", "🙄", "🤢", "🤮", "🥶", "🥵", "😵", "🤠", "🥸", "😈", "👹", "👺", "🤡", "👻", "💀", "☠️", "👽", "🤖"],
  weather: ["☀️", "🌤️", "⛅", "🌥️", "🌦️", "🌧️", "⛈️", "🌩️", "🌨️", "❄️", "🌪️", "🌫️", "🌈", "☔", "⚡", "💨", "🌡️", "☃️", "⛄", "🌬️"],
  buildings: ["🏠", "🏡", "🏢", "🏣", "🏥", "🏦", "🏨", "🏩", "🏪", "🏫", "🏬", "🏭", "🏯", "🏰", "⛪", "🕌", "🗼", "🗽", "⛺", "🎪", "🏟️", "🎡", "🎢", "🎠", "⛲", "🗿"],
  clothing: ["👕", "👖", "🧥", "👗", "👘", "👙", "👚", "👛", "👜", "🎒", "👞", "👟", "👠", "👡", "👢", "👑", "👒", "🎩", "🧢", "👓", "🕶️", "🧣", "🧤", "🧦", "👔", "🩱", "🩲", "🩳", "👘"],
  flags: ["🇩🇰", "🇸🇪", "🇳🇴", "🇫🇮", "🇮🇸", "🇩🇪", "🇫🇷", "🇬🇧", "🇺🇸", "🇯🇵", "🇰🇷", "🇨🇳", "🇧🇷", "🇮🇹", "🇪🇸", "🇵🇹", "🇳🇱", "🇧🇪", "🇨🇭", "🇦🇹", "🇦🇺", "🇨🇦", "🇲🇽", "🇷🇺", "🇮🇳", "🇬🇷", "🇹🇷", "🇵🇱", "🇺🇦", "🇿🇦"],
  hearts: ["❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "❤️‍🔥", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "❣️", "💟"],
  hands: ["👍", "👎", "👊", "✊", "🤛", "🤜", "👏", "🙌", "👐", "🤲", "🤝", "🙏", "✌️", "🤞", "🤟", "🤘", "👌", "🤌", "👈", "👉", "👆", "👇", "☝️", "✋", "🖐️", "🖖", "👋", "🤙", "💪", "🦾", "🖕", "✍️"],
  drinks: ["☕", "🍵", "🧃", "🥤", "🧋", "🍶", "🍺", "🍻", "🥂", "🍷", "🥃", "🍸", "🍹", "🧉", "🍾", "🫖"],
  vegetables: ["🥕", "🌽", "🌶️", "🫑", "🥒", "🥬", "🥦", "🧄", "🧅", "🍆", "🥔", "🫛", "🫘", "🥜", "🌰", "🫚", "🫛"],
  "sea life": ["🐙", "🦑", "🦐", "🦞", "🦀", "🐡", "🐠", "🐟", "🐬", "🐳", "🐋", "🦈", "🐊", "🐢", "🦭", "🪼", "🐚"],
  birds: ["🐦", "🐧", "🕊️", "🦅", "🦆", "🦢", "🦉", "🦤", "🪶", "🦩", "🦚", "🦜", "🐓", "🐔", "🐣", "🐤", "🐥", "🦃", "🦤"],
  insects: ["🐛", "🐜", "🐝", "🪲", "🐞", "🦗", "🪳", "🦟", "🦠", "🦋", "🐌", "🪱", "🪰", "🕷️", "🕸️", "🦂"],
  flowers: ["🌸", "🌺", "🌻", "🌹", "🌷", "💐", "🪻", "🪷", "🌼", "💮", "🏵️", "🥀", "🪴"],
  space: ["☀️", "🌙", "⭐", "🌟", "✨", "💫", "☄️", "🌍", "🌎", "🌏", "🪐", "🌑", "🌒", "🌓", "🌔", "🌕", "🌖", "🌗", "🌘"],
  weapons: ["🔫", "💣", "🧨", "🪓", "🔪", "🗡️", "⚔️", "🛡️", "🏹", "💉", "🪃"],
  money: ["💰", "💵", "💴", "💶", "💷", "💳", "💎", "🪙", "💲", "🏧", "🧾"],
  time: ["⏰", "⏱️", "⏲️", "🕰️", "⌚", "📅", "📆", "🗓️", "⌛", "⏳"],
  writing: ["✏️", "✒️", "🖊️", "🖋️", "📝", "📖", "📚", "📓", "📒", "📕", "📗", "📘", "📙", "🔖", "📑"],
  shapes: ["🔴", "🟠", "🟡", "🟢", "🔵", "🟣", "🟤", "⚫", "⚪", "🔶", "🔷", "🔸", "🔹", "▪️", "▫️", "◾", "◽", "⬛", "⬜", "🔺", "🔻"],
  zodiac: ["♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐", "♑", "♒", "♓", "⛎"],
  symbols: ["❤️", "💯", "💢", "💥", "💫", "💦", "💨", "🕳️", "💬", "👁️‍🗨️", "🗨️", "🗯️", "💭", "💤", "🔔", "🎵", "🎶", "✅", "❌", "❓", "❗", "⭕", "🚫", "♻️"],
  games: ["🎮", "🕹️", "🎲", "🧩", "♟️", "🎰", "🎳", "🪀", "🪁", "🎯", "🃏", "🀄", "🎴"],
  office: ["💼", "📁", "📂", "🗂️", "📋", "📌", "📍", "📎", "🖇️", "📏", "📐", "✂️", "🗃️", "🗄️", "🗑️"],
  party: ["🎉", "🎊", "🎈", "🎁", "🎀", "🪅", "🪩", "🎄", "🎃", "🎆", "🎇", "✨", "🧧"],
  babies: ["👶", "🍼", "🧒", "👧", "👦", "🧒", "🧒", "🚼", "👣", "🧒"],
  people: ["👨", "👩", "👴", "👵", "🧓", "👱", "👸", "🤴", "🧔", "👼", "🎅", "🤶", "🧙", "🧚", "🧛", "🧜", "🧝", "🧞", "🧟", "💂", "👮", "👷", "💆", "💇"],
  jobs: ["👨‍⚕️", "👨‍🎓", "👨‍🏫", "👨‍⚖️", "👨‍🌾", "👨‍🍳", "👨‍🔧", "👨‍🏭", "👨‍💼", "👨‍🔬", "👨‍💻", "👨‍🎤", "👨‍🎨", "👨‍✈️", "👨‍🚀", "👨‍🚒", "👮", "🕵️", "💂", "🥷", "👷"],
  romance: ["💋", "💌", "💍", "💒", "💑", "💏", "👩‍❤️‍👨", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "😘", "😍", "🥰", "😻"],
  magic: ["🔮", "🪄", "✨", "⭐", "🌟", "💫", "🧿", "🎱", "🃏", "🪬", "🧙", "🧚", "🦄", "🐉", "🧞"],
  halloween: ["🎃", "👻", "💀", "☠️", "👽", "👾", "🤖", "🎭", "🦇", "🕷️", "🕸️", "🧛", "🧟", "🧙", "😈", "👹", "👺"],
  christmas: ["🎄", "🎅", "🤶", "🦌", "🛷", "🎁", "⭐", "❄️", "☃️", "⛄", "🔔", "🕯️", "🧦", "🎿"],
  summer: ["☀️", "🏖️", "🏄", "🩱", "🩲", "🩴", "🕶️", "🧴", "⛱️", "🍦", "🍧", "🍨", "🏊", "🚤", "🌴", "🥥", "🍹"],
  winter: ["❄️", "⛄", "☃️", "🧣", "🧤", "🧥", "🎿", "🏂", "🛷", "🌨️", "🥶", "☕", "🍵", "🔥"],
};

const pickCategoryPair = (categories) => {
  const names = Object.keys(categories);
  const mainCategory = names[Math.floor(Math.random() * names.length)];
  const oddOptions = names.filter((name) => name !== mainCategory);
  const oddCategory = oddOptions[Math.floor(Math.random() * oddOptions.length)];
  return { mainCategory, oddCategory };
};

const generateRound = (roundNumber, mode) => {
  const numItems = Math.min(4 + Math.floor(roundNumber / 3), 8);
  const timeLimit = Math.max(6.0 - (roundNumber - 1) * 0.3, 3.0);
  const dataSource = EMOJI_CATEGORIES;
  const { mainCategory, oddCategory } = pickCategoryPair(dataSource);

  const mainItems = dataSource[mainCategory];
  const oddItems = dataSource[oddCategory];
  const mainSample = mainItems
    .sort(() => Math.random() - 0.5)
    .slice(0, Math.min(numItems - 1, mainItems.length));
  const oddItem = oddItems[Math.floor(Math.random() * oddItems.length)];
  const allItems = [...mainSample, oddItem];
  const correctIndex = mainSample.length;

  const indices = Array.from({ length: allItems.length }, (_, idx) => idx);
  indices.sort(() => Math.random() - 0.5);
  const shuffledItems = indices.map((idx) => allItems[idx]);
  const newCorrectIndex = indices.indexOf(correctIndex);

  return {
    round_number: roundNumber,
    images: shuffledItems,
    correct_index: newCorrectIndex,
    category: mainCategory,
    odd_category: oddCategory,
    time_limit: timeLimit,
    mode: mode
  };
};

export const GameProvider = ({ children }) => {
  const [gameState, setGameState] = useState('start'); // 'start', 'playing', 'gameover'
  const [gameMode, setGameMode] = useState('images'); // 'images' or 'emoji'
  const [currentRound, setCurrentRound] = useState(1);
  const [score, setScore] = useState(0);
  const [roundData, setRoundData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState(null); // { type: 'correct' | 'wrong' | 'timeout', index: number }
  const [leaderboard, setLeaderboard] = useState([]);
  
  // Timer state
  const [timeLeft, setTimeLeft] = useState(0);
  const [timeLimit, setTimeLimit] = useState(6);
  const [lastBonusPoints, setLastBonusPoints] = useState(0);
  const timerRef = useRef(null);
  const roundStartTimeRef = useRef(null);

  // Clear timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const startTimer = useCallback((limit) => {
    // Clear any existing timer
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    
    setTimeLimit(limit);
    setTimeLeft(limit);
    roundStartTimeRef.current = Date.now();
    
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev - 0.1;
        if (newTime <= 0) {
          clearInterval(timerRef.current);
          return 0;
        }
        return newTime;
      });
    }, 100);
  }, []);

  const stopTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  // Handle timeout
  useEffect(() => {
    if (timeLeft <= 0 && gameState === 'playing' && roundData && !feedback) {
      // Time ran out - game over
      stopTimer();
      setFeedback({ type: 'timeout', index: -1 });
      setTimeout(() => {
        setGameState('gameover');
      }, 1500); // Give more time to see timeout message
    }
  }, [timeLeft, gameState, roundData, feedback, stopTimer]);

  const fetchRound = useCallback(async (roundNumber) => {
    setIsLoading(true);
    setFeedback(null);
    setLastBonusPoints(0);

    try {
      const round = generateRound(roundNumber, gameMode);
      setRoundData(round);
      // Start timer immediately - don't wait for emojis to load
      startTimer(round.time_limit);
    } catch (error) {
      console.error('Error fetching round:', error);
    } finally {
      setIsLoading(false);
    }
  }, [startTimer, gameMode]);

  const startGame = useCallback(async (mode = 'images') => {
    setGameMode(mode);
    setGameState('playing');
    setCurrentRound(1);
    setScore(0);
    setFeedback(null);
    setLastBonusPoints(0);
    // Fetch round with the selected mode
    setIsLoading(true);
    try {
      const round = generateRound(1, mode);
      setRoundData(round);
      startTimer(round.time_limit);
    } catch (error) {
      console.error('Error fetching round:', error);
    } finally {
      setIsLoading(false);
    }
  }, [startTimer]);

  const calculateBonusPoints = useCallback((responseTimeMs, timeLimitMs) => {
    // Bonus points based on how fast they answered
    // Max bonus = 100 points if answered instantly
    // Bonus decreases linearly to 0 at time limit
    const timeRatio = 1 - (responseTimeMs / timeLimitMs);
    const bonus = Math.round(Math.max(0, timeRatio * 100));
    return bonus;
  }, []);

  const handleImageClick = useCallback(async (index) => {
    if (!roundData || feedback) return;

    stopTimer();
    
    const isCorrect = index === roundData.correct_index;
    setFeedback({ type: isCorrect ? 'correct' : 'wrong', index });

    if (isCorrect) {
      // Calculate response time
      const responseTime = Date.now() - roundStartTimeRef.current;
      const timeLimitMs = timeLimit * 1000;
      
      // Base points + time bonus
      const basePoints = 100 + (currentRound * 10);
      const bonusPoints = calculateBonusPoints(responseTime, timeLimitMs);
      const totalPoints = basePoints + bonusPoints;
      
      setLastBonusPoints(bonusPoints);
      setScore(prev => prev + totalPoints);

      // Wait for animation, then next round
      setTimeout(async () => {
        const nextRound = currentRound + 1;
        setCurrentRound(nextRound);
        await fetchRound(nextRound);
      }, 1200); // Slightly longer to see bonus points
    } else {
      // Game over - wait 3s to show correct answer
      setTimeout(() => {
        setGameState('gameover');
      }, 3000);
    }
  }, [roundData, feedback, currentRound, fetchRound, stopTimer, timeLimit, calculateBonusPoints]);

  const fetchLeaderboard = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('scores')
        .select('player_name, points, rounds_completed, created_at')
        .order('points', { ascending: false })
        .limit(10);

      if (error) {
        throw error;
      }

      setLeaderboard(data || []);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
    }
  }, []);

  const saveScore = useCallback(async (playerName) => {
    try {
      const { error } = await supabase
        .from('scores')
        .insert({
          player_name: playerName,
          points: score,
          rounds_completed: currentRound - 1
        });

      if (error) {
        throw error;
      }

      await fetchLeaderboard();
    } catch (error) {
      console.error('Error saving score:', error);
    }
  }, [score, currentRound, fetchLeaderboard]);

  const resetGame = useCallback(() => {
    stopTimer();
    setGameState('start');
    setGameMode('images');
    setCurrentRound(1);
    setScore(0);
    setRoundData(null);
    setFeedback(null);
    setTimeLeft(0);
    setLastBonusPoints(0);
  }, [stopTimer]);

  return (
    <GameContext.Provider value={{
      gameState,
      gameMode,
      currentRound,
      score,
      roundData,
      isLoading,
      feedback,
      leaderboard,
      timeLeft,
      timeLimit,
      lastBonusPoints,
      startGame,
      handleImageClick,
      saveScore,
      fetchLeaderboard,
      resetGame
    }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
};
